import React from 'react';
import PostCategory from "../../../components/pages/form/PostCategory/PostCategory";

const PostCategoryPage = () => {
    return <PostCategory />
};

export default PostCategoryPage;